module.exports = __webpack_public_path__ + "img/c6.c0bf642e.png";